import React from 'react'
import cx from 'classnames'
import { Icon, Icons } from '@/ui/icon'

type TableProps = {
  className?: string
  children: React.ReactNode
  paginationOptions?: {
    displayedDocuments: { from: number; to: number }

    hasPreviousPage: boolean
    hasNextPage: boolean

    onNextPage: () => void
    onPreviousPage: () => void
  }
}

const Table = ({ className, children, paginationOptions }: TableProps) => {
  return (
    <div>
      <div className="table-container-scroll">
        <table className={cx('table', className)}>{children}</table>
      </div>

      {paginationOptions && (
        <div className="table-pagination">
          <button
            className={cx('table-pagination-arrow', {
              'is-disabled': !paginationOptions.hasPreviousPage,
            })}
            onClick={paginationOptions.onPreviousPage}
          >
            <Icon size={16} name={Icons.ChevronLeft} />
          </button>
          <p className="table-pagination-pages">
            {paginationOptions.displayedDocuments.from + 1} -{' '}
            {paginationOptions.displayedDocuments.to}
          </p>
          <button
            className={cx('table-pagination-arrow', {
              'is-disabled': !paginationOptions.hasNextPage,
            })}
            onClick={paginationOptions.onNextPage}
          >
            <Icon size={16} name={Icons.ChevronRight} />
          </button>
        </div>
      )}
    </div>
  )
}

export default Table
